<template>
  <div id="CustodyIndex">
    <div class="Textpara">
      <p class="TextInfo">
        “ 网络游戏未成年人家长监护工程工程“是一项由多家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未 成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法一种家长实施监控的管道，使 家长纠正部分未成年人子女沉迷游戏的行为可能。
        该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注以及对用实际行动营造和谐社会的愿望。
      </p>
      <p class="Textaction">服务说明</p>
      <p
        class="TextInfo"
      >家长监护工程工程充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称帐 号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的帐号采取几种限制措施，解决未成年人沉迷网游的不良现象，如限制孩子每天玩游戏的时间 区间和长度，也可以限制只有周末才可以游戏，或者完全禁止。</p>
      <p class="Textaction">健康游戏提示</p>
      <p
        class="TextInfo"
      >随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</p>
      <p class="TextInfo">一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</p>
      <p
        class="TextInfo"
      >二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</p>
      <p class="TextInfo">三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</p>
      <p class="TextInfo">四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</p>
      <p class="TextInfo">五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustodyIndex"
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';
</style>



// WEBPACK FOOTER //
// src/components/Custody/CustodyIndex.vue